<template>
    <div class="mt-5 mb-5" style="color: black">
        <h1 class="text-center">404, Page not found</h1>
    </div>
</template>
<script>
export default {
    name:'Error404'
}
</script>